


































































































import DisplayField from '@shared/components/displays/display-field/display-field.vue';
import TableMock from '@shared/components/mocks/table-mock/table-mock.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { get } from 'lodash';
import { BPCTableField } from '@shared/interfaces/bpc-table-interface';
import DisplayFieldAmount from '@shared/components/displays/display-field-amount/display-field-amount.vue';

@Component({
  name: 'bpc-table',
  components: {
    'bpc-table-mock': TableMock,
    'bpc-display-field': DisplayField,
    'bpc-display-amount': DisplayFieldAmount,
  },
})
export default class Table extends Vue {
  @Prop(Array) readonly items: object[];
  @Prop(Array) readonly fields: BPCTableField[];
  @Prop(Boolean) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly initCheckedAll: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean; // TODO to implement
  @Prop({ type: Boolean, default: false }) readonly noCheckboxColumn: boolean;
  @Prop({ type: Boolean, default: false }) readonly noActionsColumn: boolean;
  @Prop({ type: Boolean, default: false }) readonly withFooter: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideCheckColumn: boolean;
  @Prop({ type: Number, default: 10 }) readonly nRowsInMock: number;
  @Prop({ type: Boolean, default: false }) readonly striped: boolean;
  checkedAll = false;

  mounted() {
    console.log('slots', this.$slots);
    this.checkedAll = this.initCheckedAll;
  }

  get fieldsToDisplay() {
    const allFields = this.fields;
    if (!this.noCheckboxColumn) {
      const hasCheckedColumn = this.fields.find(item => item.key === 'checked');
      if (!hasCheckedColumn) {
        allFields.unshift({
          key: 'checked',
          class: '',
          help: '',
          thStyle: { width: '20px' },
          tdStyle: { width: '20px' },
        });
      }
    }
    if (!this.noActionsColumn) {
      const hasActionsColumn = this.fields.find(item => item.key === 'actions');
      if (!hasActionsColumn) {
        allFields.push({
          order: 100,
          key: 'actions',
          class: '',
          help: '',
          thStyle: { width: '50px' },
          tdStyle: { width: '50px' },
        });
      }
    }

    return allFields;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clickOnCheckAll() {
    this.checkedAll = !this.checkedAll;
    this.items.forEach(item => this.$set(item, 'checked', this.checkedAll));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clickOnCheckOne(row: any) {
    // NOTE (To discuss)for the moment since item.ckecked is in v-model, this component
    // stores the status of this value. But it is not the best since items
    // are a property of the table itself and supose to be readonly.
    // Vuejs is not complaining about this because items is an array and
    // the checked property is not reactive.
    if (!row.item.checked) {
      // NOTE If the item checked value is false
      // we set the checkedAll to false since there
      // is at least one not selected in the list
      this.checkedAll = false;
    }
    this.$emit('checked-one', row);
  }

  // onPaginationChange(pagination: PaginationInterface) {
  //   console.log('onPaginationChange entity-table', pagination);
  //   this.$emit('pagination-change', pagination);
  // }
  getValue(item: any, field: string) {
    return get(item, field, get(item, this.camelize(field), ''));
  }

  camelize(str) {
    return str.replace(/([-_]\w)/g, g => g[1].toUpperCase());
  }
  entitySaved() {
    this.$emit('entity-saved');
  }

  onClickDisplay($event) {
    this.$emit('on-click-display', $event);
  }

  getTotalAmount(data) {
    if (!this.items) {
      return 0;
    }
    const fieldKey = data.field.key;
    const total = this.items.reduce((sum, item) => {
      if (!item['parent']) {
        let value = item[fieldKey];
        if (typeof value === 'string') {
          value = value.replace(',', '');
        }
        const parsedAsNumber = Number(String(value));
        const finalValue = !isNaN(parsedAsNumber) ? parsedAsNumber : 0;
        if (this.cancelledFilter || item['status'] !== 'cancelled') {
          return sum + finalValue;
        }
      }
      return sum;
    }, 0);

    return total.toFixed(2);
  }

  getTotalAmountFieldConfig(data) {
    const config = data.field;
    this.$delete(config, 'conditionalHide');
    this.$delete(config, 'conditionalShow');
    return config;
  }

  get cancelledFilter(): boolean {
    if (!this.items) {
      return false;
    }
    return this.items.every((val, i, arr) => val['status'] === 'cancelled');
  }

  @Watch('loading')
  onLoadingChange(val) {
    this.checkedAll = false;
  }
  @Watch('checkedAll')
  onCheckedAllChange(val) {
    this.$emit('checked-all', this.checkedAll);
  }
}
